import { Controller } from "@hotwired/stimulus"

// Filters a list of checkbox rows by text as the user types and keeps a live
// count of how many are checked. Used for the "apply to other nameplates" list
// so items are easy to find and to (de)select — a native <select multiple> made
// deselecting non-obvious.
export default class extends Controller {
  static targets = ["search", "row", "empty", "count"]

  connect() {
    this.updateCount()
  }

  filter() {
    const q = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
    let visible = 0
    this.rowTargets.forEach((row) => {
      const label = (row.dataset.label || row.textContent || "").toLowerCase()
      const show = q === "" || label.includes(q)
      row.hidden = !show
      if (show) visible++
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible !== 0
  }

  updateCount() {
    if (!this.hasCountTarget) return
    const n = this.rowTargets.filter((row) => {
      const box = row.querySelector('input[type="checkbox"]')
      return box && box.checked
    }).length
    this.countTarget.textContent = n
  }
}
